
import React from 'react';
import styles from './sectionInfo.module.scss';

type Props = {
  top: string;
  bottom: string;
  arrowLocation: 'left-left-top' | 'right-right-bottom' | 'right-left-down'| 'left-left-down';
  textLocation?: 'left' | 'right';
}

export const SectionInfo = ({top, bottom, arrowLocation, textLocation}: Props) => {
  return (
    <div className={styles.sectionInfo}>
      <div className={`${styles.content} ${textLocation ? styles[`text-${textLocation}`] : ''}`}>
        <div className={styles.top}>{top}</div>
        <div className={styles.bottom}>{bottom}</div>
        <div className={`${styles.arrow} ${styles[`arrow-${arrowLocation}`]}`} />
      </div>
    </div>
  )
}
